<script>
  /**
   * 走行記録のレスポンシブ表示
   */
  import { ROUTE_LOG_SCHEME, filterPermittedFields } from '../scheme'
  import { formatEtc } from './helpers'

  export let name
  export let log

  // スキーマから指定のフィールドを取り出す
  const pickField = (name) =>
    ROUTE_LOG_SCHEME.filter((field) => field.name === name)[0]

  // 表示するカラムの指定
  //  スキーマそのままか、あるいは計算結果を表示するのか
  const columns = filterPermittedFields([
    pickField('client'),
    { name: 'route', label: '配達先' },
    { name: 'etc', label: 'ETC' },
    { name: 'itemTimes', label: '品名' },
    { name: 'car', label: '車両' },
    pickField('memo'),
    { name: 'fee', label: '単価', isSecret: true },
  ])

  // 計算列のフォーマッタ
  //  値がない場合は ? に置き換え、joinする
  const formatter = (values) =>
    values.map((value) => (value ? value : '?')).join(' ')

  // 計算列の計算
  $: computed = {
    ...log,
    route: formatter([
      log.origin,
      '～',
      log.destination,
      '/',
      log.distance,
      'km',
    ]),
    etc: formatEtc(log),
    itemTimes: formatter([log.item, 'x', log.times, '回']),
    car: formatter([log.contractor, '-', log.carNumber, ':', log.driverName]),
    fee: [log.charge, log.payment]
      .map((num) => (num ? Number(num).toLocaleString() : '-'))
      .join(' / '),
  }
</script>

<div class="columns" data-testid={`${name}`}>
  {#each columns as column, index}
    {@const value = computed[column.name]}
    <!-- 空の場合は非表示するフィールドを判別 -->
    {#if value || !column.hideEmpty}
      <!-- 管理者用フィールドはBG色を付けて表示 -->
      <div
        class="column"
        data-testid={`${name}Column${index}`}
        class:has-background-warning-light={column.isSecret}
      >
        <!-- ラベルや値を装飾しつつ表示 -->
        <span class="label">{column.label}:</span>
        <span class="value">{value ? value : ''}</span>
      </div>
    {/if}
  {/each}
</div>

<style>
  /* ラベルの装飾 */
  span.label {
    font-weight: lighter;
    display: inline;
  }
  /* 値の装飾 */
  span.value {
    font-weight: bolder;
    display: inline;
  }
</style>
